<template>
    <div v-if="props.has" v-html="cleanHtml"></div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    html: { type: String, default: '' },
    link: { type: String, default: 'all' },
    orig: { type: Boolean, default: false },
    ship: { type: Boolean, default: false },
    has: { type: Boolean, default: true },
})

function clean() {
    let html = props.html

    if (props.ship) {
        html = ship_transform(html)
    }

    const doc = new DOMParser().parseFromString(String(html ?? ''), 'text/html')

    if (props.link !== 'all' ) {
        doc.querySelectorAll('a[href]').forEach(a => {
            const href = a.getAttribute('href') || ''

            let leave = 'none' !== props.link
            leave = leave &&  'pdf' === props.link && /\.pdf$/.test(href)

            a.setAttribute('target', '_blank')

            if (!leave) {
                a.remove()
            }
        })
    }
    doc.querySelectorAll('*[style]').forEach( el => {
        el.removeAttribute('style')
    } )

    return doc.body ? doc.body.innerHTML : ''
}

const ship_transform = (htmlString) => {
//    htmlString = htmlString.replace(/(<[^>]+) style=".*?"/gi, '$1');
    htmlString = htmlString.replace(/<br>/gi, '');
    htmlString = htmlString.replace(/&nbsp;/gi, ' ');
    htmlString = htmlString.replace(/<span[^>]*><strong[^>]*>([^<]+)<\/strong><\/span>|<strong[^>]*><span[^>]*>([^<]+)<\/span><\/strong>/gi, '<h3>$1$2</h3>');
    htmlString = htmlString.replace(/<strong>\s*<\/strong>/gi, '');
    htmlString = htmlString.replace(/<p[^>]*>\s*<\/p>/gi, '');
    htmlString = htmlString.replace(/<\/?span[^>]*>/gi, '');
    htmlString = htmlString.replace(/<\/?p[^>]*>/gi, '');
    htmlString = htmlString.replace(/<\/?em>/gi, '');
    htmlString = htmlString.replace(/<h3>(.*?)<\/h3>/gi, function(match, text) {
      return '<h3>' + text.charAt(0).toUpperCase() + text.substring(1).toLowerCase() + '</h3>';
    });
    htmlString = htmlString.replace(/<h3>(.*?)<\/h3>([^<]+)/gi, function(match, text, afterText) {
        return '<h3>' + text + '</h3><p>' + afterText + '</p>';
      });
    htmlString = htmlString.replace(/(\.\s*)([А-ЯA-Z])/g, '$1 $2');
    htmlString = htmlString.replace(/(,)([^ ])/g, '$1 $2');
    return htmlString;
}


const cleanHtml = computed(() => {
    const ret = props.orig ? props.html : clean()
    return ret
})


</script>